module.exports = __webpack_public_path__ + "img/tackled_right.5e72b344.jpg";